import React, { Component } from "react";
import { Input, Tooltip } from "../widgets";
import "./CustomerForm.css";
import Select from "../widgets/Select";

import { VALID_STATES } from "../../utils/registration";

class CustomerForm extends Component {
  render() {
    const validStates = VALID_STATES.map(option => {
      return { value: option, label: option };
    });

    return (
      <div className="customer-form">
        <div className="customer-form-row">
          <label className="street-name">
            <span className="label-text">Customer Name</span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.name}
                onChange={e => this.props.handleFieldOnChange("name", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.name : null}
              />
            </div>
          </label>
        </div>
        <div className="customer-form-row">
          <label className="customer-nmi">
            <span className="label-text">
              NMI (optional)
              <Tooltip id="customerRegistration.nmi" />
            </span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.nmi}
                onChange={e => this.props.handleFieldOnChange("nmi", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.nmi : null}
              />
            </div>
          </label>
        </div>
        <h2>Site Address</h2>
        <div className="customer-form-row">
          <label className="street-number">
            <span className="label-text">Address Line 1</span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.addressLine1}
                onChange={e => this.props.handleFieldOnChange("addressLine1", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.addressLine1 : null}
              />
            </div>
          </label>
        </div>
        <div className="customer-form-row">
          <label className="city">
            <span className="label-text">Suburb</span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.city}
                onChange={e => this.props.handleFieldOnChange("city", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.city : null}
              />
            </div>
          </label>
          <label className="state">
            <span className="label-text">State</span>
            <div className="widget">
              <Select
                placeholder={null}
                clearable={false}
                readOnly={this.props.readOnly}
                options={validStates}
                value={this.props.state}
                onChange={e => this.props.handleFieldOnChange("state", e)}
                error={!this.props.readOnly ? this.props.errors.state : null}
                style={{ width: "6.8em" }}
              />
            </div>
          </label>
        </div>
        <div className="customer-form-row">
          <label className="postcode">
            <span className="label-text">Postcode</span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.postcode}
                onChange={e => this.props.handleFieldOnChange("postcode", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.postcode : null}
              />
            </div>
          </label>
        </div>
        <div className="customer-form-row">
          <label className="email">
            <span className="label-text">Email</span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.email}
                onChange={e => this.props.handleFieldOnChange("email", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.email : null}
              />
            </div>
          </label>
          <label className="phone">
            <span className="label-text">Phone</span>
            <div className="widget">
              <Input
                readOnly={this.props.readOnly}
                value={this.props.phone}
                onChange={e => this.props.handleFieldOnChange("phone", e.target.value)}
                error={!this.props.readOnly ? this.props.errors.phone : null}
              />
            </div>
          </label>
        </div>
      </div>
    );
  }
}

export default CustomerForm;
